import React from "react";
import config from "./../../../config/config";

const Metodos =( props) => {
    let {className} = props;
    return(
        <div className={`${className}wc metodosIcons text-center`}>
            <img src={config.pagosProcesadosEpaycoLogo} alt="logo-epayco" style={{ maxHeight: "20px" }} />
            <div className="mt-3">
                <p className="font-weight-bold small">Medio de pago disponible</p>
                <div>
                    <img src="/img/pse.png" alt="Icono de PSE" />
                    <img src="/img/dinners.png" alt="Icono de Dinners" />
                    <img src="/img/amex.png" alt="Icono de Amex" />
                    <img src="/img/mastercard.png" alt="Icono de Mastercard" />
                    <img src="/img/visa.png" alt="Icono de Visa" />
                </div>
            </div>
        </div>
    )
}

export default Metodos;
